import { Navigate, Route, Routes } from "react-router-dom";
import { AppProviders } from "@/providers/AppProviders";
import { AppShell } from "@/components/app-shell/AppShell";

import OverviewPage from "@/app/overview/page";
import StatisticsPage from "@/app/statistics/page";
import InboxPage from "@/app/inbox/page";
import InboxFormsPage from "@/app/inbox/forms/page";
import InboxEmailPage from "@/app/inbox/email/page";
import InboxChatPage from "@/app/inbox/chat/page";
import IssuesPage from "@/app/issues/page";
import AccountsPage from "@/app/accounts/page";
import DevicesPage from "@/app/devices/page";
import DevicesEnrollPage from "@/app/devices/enroll/page";
import DevicesProfilesPage from "@/app/devices/profiles/page";
import DevicesBrandingPage from "@/app/devices/branding/page";
import GroupsPage from "@/app/groups/page";
import ModelsPage from "@/app/models/page";
import ModelDetailPage from "@/app/models/[slug]/page";
import ModelsUploadPage from "@/app/models/upload/page";
import ModelsReviewPage from "@/app/models/review/page";
import ModelsHistoryPage from "@/app/models/history/page";
import ModelsPreviewRedirectPage from "@/app/models/preview/page";
import AssetsPage from "@/app/content/assets/page";
import DocsPage from "@/app/docs/page";
import ChangelogPage from "@/app/changelog/page";
import SettingsPage from "@/app/settings/page";
import UnauthorizedPage from "@/app/unauthorized/page";
import OauthAuthorizePage from "@/app/oauth/authorize/page";
import OauthDesktopReturnPage from "@/app/oauth/desktop-return/page";

export function App() {
  return (
    <AppProviders>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="/oauth/authorize" element={<OauthAuthorizePage />} />
          <Route
            path="/oauth/desktop-return"
            element={<OauthDesktopReturnPage />}
          />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/statistics" element={<StatisticsPage />} />
          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/inbox/forms" element={<InboxFormsPage />} />
          <Route path="/inbox/email" element={<InboxEmailPage />} />
          <Route path="/inbox/chat" element={<InboxChatPage />} />
          <Route path="/issues" element={<IssuesPage />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/customers" element={<Navigate to="/accounts" replace />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/devices/enroll" element={<DevicesEnrollPage />} />
          <Route path="/enroll" element={<Navigate to="/devices/enroll" replace />} />
          <Route path="/devices/profiles" element={<DevicesProfilesPage />} />
          <Route path="/devices/branding" element={<DevicesBrandingPage />} />
          <Route
            path="/devices/policies"
            element={<Navigate to="/devices/profiles" replace />}
          />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/models/upload" element={<ModelsUploadPage />} />
          <Route path="/models/review" element={<ModelsReviewPage />} />
          <Route path="/models/history" element={<ModelsHistoryPage />} />
          <Route path="/models/preview" element={<ModelsPreviewRedirectPage />} />
          <Route path="/models/:slug" element={<ModelDetailPage />} />
          <Route path="/content/assets" element={<AssetsPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/changelog" element={<ChangelogPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </AppShell>
    </AppProviders>
  );
}
